import { OhiUniversityComponent } from './ohi-university.component';
import { RouterModule, Router } from '@angular/router';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { OhiUniversityRoutingModule } from './ohi-university-routing.module';
import { WebinarsComponent } from './webinars/webinars.component';
import { ResourcesComponent } from './resources/resources.component';
import { Page404homeComponent } from './page404home/page404home.component';
import { FormsModule } from '@angular/forms';
import { GridModule } from '@progress/kendo-angular-grid';
import { DatePickerModule } from '@progress/kendo-angular-dateinputs';
import { MatDatepickerModule} from "@angular/material/datepicker";
import { MatInputModule} from "@angular/material/input";
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatNativeDateModule } from '@angular/material/core';
import {MatSelectModule} from '@angular/material/select';
import {MatCheckboxModule} from '@angular/material/checkbox';
import {MatListModule} from '@angular/material/list';
import { MatButtonModule } from '@angular/material/button';
import { BlogsComponent } from './blogs/blogs.component';
import { EditorModule } from '@progress/kendo-angular-editor';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';

@NgModule({  
  imports: [
    RouterModule,
    CommonModule,
    FormsModule,
    GridModule,
    DatePickerModule,
    MatFormFieldModule,
    MatDatepickerModule,
    MatInputModule,
    MatNativeDateModule,
    MatSelectModule,
    MatCheckboxModule,    
    MatButtonModule,
    MatListModule,
    EditorModule,
    OhiUniversityRoutingModule,
    FontAwesomeModule
  ],
  declarations: [  
    OhiUniversityComponent,    
    WebinarsComponent,
    ResourcesComponent,
    Page404homeComponent,
    BlogsComponent
  ]
})
export class OhiUniversityModule { }
